import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

// Skip Sentry during react-snap prerender (HeadlessChrome)
const isSnapRender = typeof window !== "undefined" && (window as any).__IS_SNAP_RENDER;

if (!isSnapRender) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN || "https://b4615a6cb54832e8c6da0bd90a1e2ad0@o561961.ingest.us.sentry.io/4510945917206528",
    integrations: [new BrowserTracing()],
    // Set tracesSampleRate to a value between 0.0 and 1.0 to enable performance monitoring.
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE) || 0.05,
    environment: process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV || "production",
    release: process.env.REACT_APP_SENTRY_RELEASE,
    beforeSend(event, hint) {
      try {
        // Filter out noisy ResizeObserver errors or other known benign messages
        const err = hint?.originalException as any;
        if (err && typeof err.message === "string") {
          const msg = err.message || "";
          if (msg.includes("ResizeObserver loop limit exceeded")) {
            return null;
          }
        }
      } catch (e) {
        // ignore
      }
      return event;
    }
  });
}

export default Sentry;
